/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useLayout} from '../core'

const Footer: FC = () => {
  const {classes} = useLayout()
  return (
    <div className='footer py-4 d-flex flex-lg-column' id='kt_footer'>
      {/* begin::Container */}
      <div
        className={`${classes.footerContainer} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        {/* begin::Copyright */}
        <div className='text-white order-2 order-md-1'>
          <span className='text-white fw-bold me-2'>{new Date().getFullYear()} &copy;</span>
          <span  className='text-white '>
          Mall Aventura. All rights reserved.
          </span>
        </div>
        {/* end::Copyright */}

        {/* begin::Nav */}
    
      </div>
      {/* end::Container */}
    </div>
  )
}

export {Footer}
